<template>
  <div class="text-xs">
    <button v-bind="$attrs" v-on="inputListeners" class="btn shadow">{{label}}</button>
  </div>
</template>

<script>
export default {
  name: "VButton",
  props: {
    label: { type: String, default: "Untitiled" },
    type: { type: String, default: "button" },
    value: { type: String, default: "" }
  },
  computed: {
    inputListeners: function() {
      var vm = this;
      // `Object.assign` merges objects together to form a new object
      return Object.assign(
        {},
        // We add all the listeners from the parent
        this.$listeners,
        // Then we can add custom listeners or override the
        // behavior of some listeners.
        {
          // This ensures that the component works with v-model
          input: function(event) {
            vm.$emit("input", event.target.value);
          }
        }
      );
    }
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
label {
  display: block;
}
input {
  border: 1px solid rgb(85, 86, 143, 0.6);
}
input:active,
input:focus,
input:hover {
  outline: none;
}
input:focus {
  border: 1px solid rgb(85, 86, 143);
}
</style>
